<!-- @format -->

<modal-base>
  <slot></slot>
  <script>
    export default {
      state: { isOpen: false },
      onUpdated(props, state) {
        if (props.isOpen != state.isOpen) {
          state.isOpen = props.isOpen;
          if (props.isOpen) {
            if (props.onBeforeShow) {
              props.onBeforeShow();
            }
            window.$(this.root).fadeIn(100, function () {
              if (props.onShow) {
                props.onShow();
              }
            });
          } else {
            if (props.onBeforeHide) {
              props.onBeforeHide();
            }
            window.$(this.root).fadeOut(100, function () {
              if (props.onHide) {
                props.onHide();
              }
            });
          }
        }
      },
    };
  </script>
</modal-base>
